import { render, staticRenderFns } from "./RegPrasymasTurtas.vue?vue&type=template&id=bacfbb40&scoped=true&"
import script from "./RegPrasymasTurtas.vue?vue&type=script&lang=js&"
export * from "./RegPrasymasTurtas.vue?vue&type=script&lang=js&"
import style0 from "./RegPrasymasTurtas.vue?vue&type=style&index=0&id=bacfbb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacfbb40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VDivider,VFooter,VRow,VSpacer})
